import * as React from "react";
import Modal from "../../ui/modal/Modal";
import LeadEmailSentEvent from "../../../model/lead/event/LeadEmailSentEvent";
import JobEmailSentEvent from "../../../model/job/event/JobEmailSentEvent";
import './emailPreviewModal.scss';
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";

const sanitizeHtml = require("sanitize-html");

interface IProps {
	/**
	 * On close callback.
	 */
	onClose: () => void;
	/**
	 * Event with diplayed message.
	 */
	messageEvent: LeadEmailSentEvent | JobEmailSentEvent;
}

export default class EmailPreviewModal extends React.Component<IProps, {}> {
	render() {
		const html = sanitizeHtml(this.props.messageEvent.data.message, {
			allowedTags: sanitizeHtml.defaults.allowedTags.concat(['img', 'h1', 'h2', 'del']),
			allowedAttributes: {
				...sanitizeHtml.defaults.allowedAttributes,
				img: ['src', 'alt', 'style']
			}
		});

		return (
			<Modal fixedWidth onCloseClicked={this.props.onClose} title={"Email preview"}>
				<div className="c-email-preview-modal_row">
					<div className="c-email-preview-modal_label">To:</div>
					{this.props.messageEvent.data.receiverEmails}
				</div>
				<div className="c-email-preview-modal_row">
					<div className="c-email-preview-modal_label">Subject:</div>
					{this.props.messageEvent.data.subject}
				</div>
				<div className="c-email-preview-modal_row">
					<div className="c-email-preview-modal_message-label">Message:</div>
					<div dangerouslySetInnerHTML={{__html: html}} className="c-email-preview-modal_content"/>
				</div>
				<ButtonPrimary label={"Close preview"} onClick={this.props.onClose}/>
			</Modal>
		);
	}
}